import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Pagination, { getPagingInfo } from '../../Pagination';
import PaginationHeader from '../../PaginationHeader';
import pageSizeUtil from '../../../util/pageSize';
import noop from '../../../util/noop';
import useContainerProps from '../../../hooks/useContainerProps';

/** renders a pagination module intended for use inside a section */
const PaginationModule = props => {
  props = useContainerProps(props);

  const { activePage, children, collection, collectionMeta: { total_count } = {},
    loadCollection = noop, onPageChange = noop, pageSize,
    resetScroll, setActivePage = noop } = props;

  const handlePageChange = (page) => {
    setActivePage(page);
    onPageChange(page);
    if (resetScroll) {
      window.scrollTo(0, 0);
    }
    loadCollection();
  }

  const changePageSize = (pageSize) => {
    pageSizeUtil(pageSize);
    handlePageChange(1);
  }

  const pagingInfo = getPagingInfo({
    data: collection,
    pageSize,
    totalCount: total_count
  });

  useEffect(() => {
    if (!activePage) {
      handlePageChange(1);
    }
  }, []);

  return (
    <>
      <PaginationHeader
        {...props}
        changePageSize={changePageSize}
        dataSize={pagingInfo.dataSize}
        hasPagination={pagingInfo.hasPagination}
        isLoadingData={!pagingInfo.totalCount}
        pSize={pagingInfo.pageSize}
        showPageSizeDropdown={!pageSize}
        totalCount={pagingInfo.totalCount}
      />
      {children}
      <Pagination
        {...props}
        data={collection}
        isLoadingData={!total_count}
        onPageChange={handlePageChange}
        totalCount={total_count}
      />
    </>
  );
}

PaginationModule.propTypes = {
  activePage: PropTypes.number,
  children: PropTypes.node,
  collection: PropTypes.array,
  collectionMeta: PropTypes.shape({
    total_count: PropTypes.number
  }),
  loadCollection: PropTypes.func,
  maxButtons: PropTypes.number,
  onPageChange: PropTypes.func,
  pageSize: PropTypes.number,
  resetScroll: PropTypes.bool,
  resultsDisplayed: PropTypes.bool,
  setActivePage: PropTypes.func
};

PaginationModule.defaultProps = {
  resetScroll: true,
  resultsDisplayed: true
};

export default PaginationModule;
